package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface IdentityProxyEnvironment : Environment {
    val host: String
    val rewardsPath: String
}

@JsExport
abstract class BaseIdentityProxyEnvironment : IdentityProxyEnvironment {
    override val rewardsPath: String = "rewards-flows/v1"
}

@JsExport
data class DevIdentityProxyEnvironment(
    override val host: String = "dev.redwolf.external.plat.vizio.com"
) : BaseIdentityProxyEnvironment()

@JsExport
data class StageIdentityProxyEnvironment(
    override val host: String = "stage.redwolf.external.plat.vizio.com"
) : BaseIdentityProxyEnvironment()

@JsExport
data class PreProdIdentityProxyEnvironment(
    override val host: String = "preprod.redwolf.external.plat.vizio.com"
) : BaseIdentityProxyEnvironment()

@JsExport
data class ProdIdentityProxyEnvironment(
    override val host: String = "prod.redwolf.external.plat.vizio.com"
) : BaseIdentityProxyEnvironment()

fun chooseIdentityProxyEnvironment(envConfig: IdentityProxyEnvironmentConfig): IdentityProxyEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdIdentityProxyEnvironment()
        EnvironmentGroup.PREPROD -> PreProdIdentityProxyEnvironment()
        EnvironmentGroup.STAGE -> StageIdentityProxyEnvironment()
        EnvironmentGroup.DEV -> DevIdentityProxyEnvironment()
        EnvironmentGroup.TEST -> TODO("Test Identity Proxy Environment not defined yet!")
    }
}
